import { render, staticRenderFns } from "./Workbenchstatistical.vue?vue&type=template&id=54300455&scoped=true&"
import script from "./Workbenchstatistical.vue?vue&type=script&lang=js&"
export * from "./Workbenchstatistical.vue?vue&type=script&lang=js&"
import style0 from "./Workbenchstatistical.vue?vue&type=style&index=0&id=54300455&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54300455",
  null
  
)

export default component.exports